import script from "./SkyChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyChart.vue?vue&type=script&setup=true&lang=js"

import "./SkyChart.vue?vue&type=style&index=0&id=d52a3d34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d52a3d34"]])

export default __exports__